import { render } from "./uiButtonSwitch.vue?vue&type=template&id=09ccb94a&scoped=true"
import script from "./uiButtonSwitch.vue?vue&type=script&lang=js"
export * from "./uiButtonSwitch.vue?vue&type=script&lang=js"

import "./uiButtonSwitch.vue?vue&type=style&index=0&id=09ccb94a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ccb94a"]])

export default __exports__